/** A shared section divider keeps the page grid aligned without enclosing content. */
export function PublicSectionRule() {
  return <div className="public-section-rule" aria-hidden="true"><span/><span/></div>;
}
